export default __webpack_public_path__ + "static/media/headshot1.1bf6de14.jpg";